import { MASTER_ADMIN_URL_PREFIX } from '@/const/shared';
import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getMasterAdminMasterServiceAgreementPath = () => {
  return urlHelper(`${MASTER_ADMIN_URL_PREFIX}/master-service-agreement`);
};
